import { Collapse, CollapseProps } from 'antd';
import React from 'react';

import styled from 'styled-components';

export const StyledDrawerCollapse = styled(Collapse)`
  &.ant-collapse {
    margin-top: -12px;
    padding-bottom: 12px;
    > .ant-collapse-item {
      > .ant-collapse-header {
        padding-left: 0;
        padding-right: 0;
        font-weight: 600;
      }
      > .ant-collapse-content > .ant-collapse-content-box {
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;
      }
    }
  }
`;

export interface IDrawerCollapseProps
  extends Omit<CollapseProps, 'children' | 'items'> {
  title?: React.ReactNode;
  firstPanelProps?: Partial<CollapseProps['items']>;
  children?: React.ReactNode;
}

/**
 * Elemento divisore con titolo
 */
export function DrawerCollapse(props: IDrawerCollapseProps) {
  const { title, defaultActiveKey, firstPanelProps, children, ...rest } = props;
  if (!title) return null;

  const items: CollapseProps['items'] = [
    {
      label: title,
      key: 'default-key',
      ...firstPanelProps,
      children,
    },
  ];

  return (
    <StyledDrawerCollapse
      ghost
      items={items}
      defaultActiveKey={['default-key']}
      {...rest}
    />
  );
}
